export type ParentShellContentInsetProfile =
  | 'parent-financial-aid-parity-v1'
  | 'parent-mobile-zero-main-inset-v1';

export const PARENT_FINANCIAL_AID_PARITY_ROUTE_PREFIXES = [
  '/parent/portal/financialaid',
  '/parent/portal--new/financialaid',
  '/portal/family/financial-aid',
  '/portal/family/financialaid',
] as const;

export const PARENT_MOBILE_ZERO_MAIN_INSET_ROUTE_PREFIXES = [
  '/parent/portal/enrollment',
  '/parent/portal--new/enrollment',
  '/parent/portal/applications',
  '/parent/portal--new/applications',
  '/parent/portal/settings',
] as const;

const matchesRoutePrefix = (path: string, prefix: string): boolean =>
  path === prefix || path.startsWith(prefix + '/');

export const resolveParentShellContentInsetProfile = (
  canonicalPath: string,
): ParentShellContentInsetProfile | undefined => {
  if (
    PARENT_FINANCIAL_AID_PARITY_ROUTE_PREFIXES.some((prefix) =>
      matchesRoutePrefix(canonicalPath, prefix),
    )
  ) {
    return 'parent-financial-aid-parity-v1';
  }

  if (
    PARENT_MOBILE_ZERO_MAIN_INSET_ROUTE_PREFIXES.some((prefix) =>
      matchesRoutePrefix(canonicalPath, prefix),
    )
  ) {
    return 'parent-mobile-zero-main-inset-v1';
  }

  return undefined;
};
